require('./followersFollowingController');
require('../../shared/userPhoto/userPhotoDirective');

"use strict";

angular.module('app.myHockeyTv.followersFollowing', [
    'app.myHockeyTv.followersFollowing.followersFollowingController'
])
    .config([
        '$stateProvider',
        function ($stateProvider) {
            $stateProvider.state('app.myHockeyTv.followersFollowing', {
                url: '/followers_following',
                templateUrl: 'components/myHockeyTv/followersFollowing/followersFollowingView.html',
                controller: 'app.myHockeyTv.followersFollowing.followersFollowingController',
                subTitle: 'Find New Profiles',
                isChildState: true
            });
        }
    ]);


// WEBPACK FOOTER //
// ./app.v2/components/myHockeyTv/followersFollowing/followersFollowing.js